<script>
    import ReportsService from '../services/reports.service';
    import Toast from './Toast.svelte';
    import { createEventDispatcher } from 'svelte';

    export let params = '';

    const dispatch = createEventDispatcher();

    let indicatorsRemoved = function(response) {
		dispatch('indicatorsRemoved', {
			response : response,
		});
    }

    let isActivityReport = false;

    let removeIndicator = function() {
        const selection = getSelectedSections();

        if (isActivityReport) {
            console.log('Remove activity indicator', selection);
            ReportsService.removeEmployeeActivityIndicator(selection).then(() => {
                indicatorsRemoved();
            });
        } else {
            ReportsService.removeKpiIndicator(selection).then(() => {
                indicatorsRemoved();
            });
        }
    }

    const getSelectedSections = () => {
        const selectedFew = jQuery('.dragging');

        if (selectedFew.length) {
            const selectedSections = [];
            selectedFew.each(function() {
                selectedSections.push({
                    kpi_id: jQuery(this).data('id'),
                    date: jQuery(this).data('date'),
                    field: jQuery(this).data('field'),
                    employee_id: jQuery(this).data('employee'),
                    metric_id: jQuery(this).data('metric'),
                });
            });
            return selectedSections;
        } else {
            const selectedOne = jQuery('.cellSelected');
            return [{
                kpi_id: selectedOne.data('id'),
                date: selectedOne.data('date'),
                field: selectedOne.data('field'),
                employee_id: selectedOne.data('employee'),
                metric_id: selectedOne.data('metric'),
            }];
        }
    };

    let copyCells = function() {
		fireCopyEventFunction();
        jQuery("#dataCopied").toast('show')
        setTimeout(() => {
            jQuery("#dataCopied").toast('hide')
        }, 2000);
    }

    let emptyCells = function() {
		fireClearEventFunction();
    }

    $: isActivityReport = params && params.subMenu === 'activity';
</script>

<Toast id="dataCopied" text="Data copied" class="success"></Toast>
<div class="dropdown float-right mr-2" id="selected-menu">
    <button class="btn btn-sm btn-outline-dark">
        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
    </button>

    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li on:click={removeIndicator} class="dropdown-item">
            <i class="fa fa-eraser"></i>
            Remove Indicator
        </li>

        {#if !isActivityReport}
             <li on:click={copyCells} class="dropdown-item">
                 <i class="fa fa-clone"></i>
                 Copy Cells
             </li>
             <li on:click={emptyCells} class="dropdown-item">
                 <i class="fa fa-trash-o"></i>
                 Empty Cells
             </li>
        {/if}
    </ul>
</div>
